<div class="row p-2 mb-3 align-items-center">
  <div class="col-12 col-md-7 text-start">
    <div class="page-title-heading">
      <div class="page-title-icon"><i class="fa-solid fa-user-check"></i></div>
      <div>
        Détail de présence
        <div class="page-title-subheading">Détail d'un relevé de présence</div>
      </div>
    </div>
  </div>
  <div class="col-12 col-md-5 text-end">
    <app-header></app-header>
  </div>
</div>

<div class="container">
    <div class="row">
        <div class="col-10 mx-10">
            <div class="card">
                <div class="container">
                  <div class="row">
                    <div class="col-12 col-md-6">
                        <dl>
                            <dt>Libellé</dt>
                            <dd>{{data?.name}}</dd>
                        </dl>
                       
                    </div>
                    <div class="col-12 col-md-6">
                        <dl>
                            <dt>Catégorie</dt>
                            <dd>{{data?.category}}</dd>
                        </dl>
                    </div>
                  </div>
                </div>
                <div class="card-body">
                    <table class="table table-sm">
                        <thead>
                            <th>#</th>
                            <th>Nom et prénom(s)</th>
                            <th>Etat</th>
                        </thead>
                        <tbody>
                            <tr *ngFor="let d of data?.details; let i=index">
                                <td>{{i+1}}</td>
                                <td *ngIf="data?.category=='Enseignant'">{{d.pac?.professor?.lastname}} {{d.pac?.professor?.firstname}}</td>
                                <td *ngIf="data?.category=='Apprenant'">{{d.sac?.student?.lastname}} {{d.sac?.student?.firstname}}</td>
                                <th>
                                   <p>{{d.type}}</p>
                                    <ng-container *ngIf="d.type == 'Retard'">
                                        {{d.coming_time | date:"dd-MM-yyyy hh:mm:ss"}}
                                    </ng-container>    
                                    <ng-container *ngIf="d.type == 'Absent'">
                                        <p>{{d.motif}}</p>
                                        <div *ngIf="d.motif_filename" (click)="getFile2(data?.code+'/'+d.motif_filename)" class="text-primary"><u>Voir le fichier</u></div>
                               
                                    </ng-container>    
                                </th>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
    </div>
</div>

<ng-template #contentPDF let-offcanvas>
	<div class="offcanvas-header">
    
		<h4 class="offcanvas-title">Visualiseur de fichier</h4>
		<button id="closePDFBtn" type="button" class="btn-close" aria-label="Close" (click)="offcanvas.dismiss('Cross click')"></button>
	</div>
	<div class="offcanvas-body">
        <ngx-extended-pdf-viewer [src]="pdfSrc"
        style="width: 100%; height: 100%"
        ></ngx-extended-pdf-viewer>
	</div>
</ng-template>